import { render, staticRenderFns } from "./StripeProductWidget.vue?vue&type=template&id=3ba89a0d&scoped=true"
import script from "./StripeProductWidget.vue?vue&type=script&lang=js"
export * from "./StripeProductWidget.vue?vue&type=script&lang=js"
import style0 from "./StripeProductWidget.vue?vue&type=style&index=0&id=3ba89a0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba89a0d",
  null
  
)

export default component.exports